/* ---------------------------------------------------------
* This file defines all development constants
------------------------------------------------------------ */

export const API_BASE_URL = 'https://subastasback.clubpremier.info/api/v1/auctions/public';
export const API_BASE_URL_PRIVATE = 'https://subastasback.clubpremier.info/api/v1/auctions/private';
export const API_BASE_URL_MEMBER = 'https://member.clubpremier.info/api/v1';
export const API_SOCKET = 'https://subastasnotify.clubpremier.info';
export const MEMBER_URL = 'https://member.clubpremier.info';
export const SUBASTAS_URL = 'https://subastas.clubpremier.info';
